import React from "react";
import { Link } from "react-router-dom";

const Speaking = () => {
  return (
    <>
      <div className="page-hero">
        <span className="page-hero-eyebrow">Speaking &amp; Workshops</span>
        <h1>Straight talk.<br /><em>From someone<br />who's done it.</em></h1>
        <p>Laura speaks to real estate leadership teams, principal groups and industry events across Australia — with practical, unvarnished insight from 15+ years running the people side of the business. No slides full of theory. No consultant clichés. Just what actually works.</p>
        <Link to="/contact" className="btn btn-gold" style={{marginTop:'1rem'}}>Book Laura for your event</Link>
      </div>

      <section className="section section-black">
        <div style={{marginBottom:'4rem',maxWidth:'720px'}}>
          <span className="eyebrow">Signature topics</span>
          <h2 className="h-lg" style={{color:'var(--white)'}}>Five sessions.<br />Zero fluff.</h2>
        </div>
        <div className="three-col">
          {[
            ["01","Hiring right — every time","How to interview like you mean it. The signals that matter, the questions that reveal, and the red flags most principals miss."],
            ["02","Building a retention-first culture","What actually keeps your best people — and why it isn't ping-pong tables or perks."],
            ["03","Difficult conversations for leaders","How to have the exit conversation, the feedback conversation, and the pay conversation — with clarity and respect."],
            ["04","Structuring for growth","The org design decisions that quietly determine whether your agency scales or stalls."],
            ["05","Leadership in a small agency","Playing GM without a GM title — how principals of boutique agencies lead their people through growth."],
            ["06","Custom keynotes","Have a specific theme for your conference or leadership offsite? Laura tailors every session to the room she's speaking to."]
          ].map(([n,t,d])=>(
            <div key={n} className="service-card">
              <span className="service-num">{n}</span>
              <h3>{t}</h3>
              <p>{d}</p>
              <Link to="/contact">Enquire →</Link>
            </div>
          ))}
        </div>
      </section>

      <section className="section section-black2">
        <div className="two-col">
          <div>
            <span className="eyebrow">Formats</span>
            <h2 className="h-md" style={{color:'var(--white)',marginBottom:'2rem'}}>Choose the format<br />that fits your room.</h2>
            <p className="body-lg" style={{maxWidth:'480px'}}>Whether it's a 30-minute keynote for a conference or a full-day workshop for your leadership team, Laura builds every session around your people, your context and the outcomes you actually need.</p>
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:'1rem'}}>
            {[
              ["Keynote (30–45 min)","For conferences, industry events and principal meetups. Sharp, punchy, provocative."],
              ["Half-day workshop","For leadership teams. Interactive, applied, walk-out-with-action-items."],
              ["Full-day intensive","Deep work with a single team. Diagnostics, workshopping, and a written plan."],
              ["Panel & fireside","Moderated conversations for industry events — people, culture, hiring, growth."]
            ].map(([t,d])=>(
              <div key={t} className="card">
                <h3>{t}</h3>
                <p>{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-black">
        <div style={{marginBottom:'3.5rem',maxWidth:'720px'}}>
          <span className="eyebrow">What audiences say</span>
          <h2 className="h-lg" style={{color:'var(--white)'}}>Real rooms.<br />Real reactions.</h2>
        </div>
        <div className="testi-row">
          {[
            ["Laura was the standout of our entire conference. Practical, funny, and completely unafraid to say the things the rest of us dance around.","Event organiser","National real estate summit"],
            ["We booked Laura for a leadership half-day. Two months later, our retention plan is unrecognisable — and working.","Principal","Boutique agency, Bayside"],
            ["Every single one of our leaders walked out with something they were going to do differently on Monday. That's rare.","Head of PM","Multi-office agency, Melbourne"]
          ].map(([t,n,r])=>(
            <div key={n} className="testi">
              <span className="testi-mark">“</span>
              <p className="testi-text">{t}</p>
              <div className="testi-name">{n}</div>
              <div className="testi-role">{r}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="section section-black" style={{textAlign:'center',borderTop:'1px solid var(--border)'}}>
        <h2 className="h-xl" style={{color:'var(--white)',marginBottom:'1.25rem'}}>Have a room<br /><em style={{fontStyle:'normal',color:'var(--gold)'}}>that needs waking up?</em></h2>
        <p style={{fontSize:'1rem',color:'rgba(255,255,255,0.70)',fontWeight:300,maxWidth:'460px',margin:'0 auto 2.5rem',lineHeight:1.8}}>Tell us about your event, your audience and what you want them walking out with. We'll come back with a session tailored to your team.</p>
        <Link to="/contact" className="btn btn-gold">Book Laura</Link>
      </section>
    </>
  );
};

export default Speaking;
